import React, {Component, Fragment} from "react";
import M from "moment/moment";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import ReceivingUnitNOSInputs from "./receivingUnitNOSInputs";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../../Services/Api";
import {constructDataDetailUnitNOS, constructGenSeqPayload, validateDataDetailUnitNOS} from "../util";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import {v4 as uuidv4} from "uuid";
import {HttpStatus} from "../../../../common/Constants";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ReceivingUnitNOSProcess extends Component {
    tableColumns = [
        {
            name: "id",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
            },
        },
        {
            name: "kodeVarian",
            label: "Kode Varian*",
            options: {
                customBodyRender: (value, {rowIndex, rowData}) => {
                    const isSaved = rowData[rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_kode_varian_${rowIndex}`}
                            box="search"
                            name="kodeVarian"
                            containerclassname="margin-bottom-none"
                            readOnly={isSaved}
                            menuPosition="fixed"
                            options={this.state.dataVariant.map(
                                item => mapToObjectDDL(
                                    item.kodeVariant,
                                    item.kodeVariant
                                ))}
                            value={value ? mapToObjectDDL(value?.label, value?.value) : null}
                            onChange={(value) =>
                                this.handleSelectCodeVariant(rowIndex, "kodeVarian", value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "250px"},
                }),
            },
        },
        {
            name: "namaVarian",
            label: "Nama Varian",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "frameNumber",
            label: "NoKa*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_frame_number"
                            name="frameNumber"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "engineNumber",
            label: "NoSin*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_frame_number"
                            name="engineNumber"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna*",
            options: {
                customBodyRender: (value, {rowIndex, rowData}) => {
                    const isSaved = rowData[rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_kode_warna_${rowIndex}`}
                            box="search"
                            name="kodeWarna"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            menuPosition="fixed"
                            options={!R.isNil(this.state.dataWarna) && !R.isEmpty(this.state.dataWarna)
                                ? this.state.dataWarna[rowIndex]?.map(
                                    item => mapToObjectDDL(
                                        item.kodeWarna,
                                        item.id
                                    )) : []
                            }
                            value={value}
                            onChange={(value) =>
                                this.handleSelectColorCode(rowIndex, "kodeWarna", value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "250px"},
                }),
            },
        },
        {
            name: "namaWarnaPabrik",
            label: "Nama Warna",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
            },
        },
        {
            name: "rfsStatus",
            label: "RFS",
            options: {
                customBodyRender: (val, {rowIndex, rowData}) => {
                    const isSaved = rowData[rowData.length - 1];
                    return (
                        <SimpleCheckBox
                            id="input_checkbox_rfs"
                            type="checkbox"
                            name="rfsStatus"
                            disabled={isSaved}
                            checked={!!R.equals(val, "RFS")}
                            onChange={({target}) =>
                                this.handleValueChange(rowIndex, target.name, target.checked)
                            }
                        />
                    );
                },
                sort: false,
            },
        },
        {
            name: "yearManufactured",
            label: "Thn. Prod",
            options: {
                customBodyRender: (val, {rowIndex, rowData}) => {
                    const isSaved = rowData[rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_thn_prod"
                            box="onlyNumber"
                            name="yearManufactured"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
            },
        },
        {
            name: "kodeLocation",
            label: "[*] All Locator",
            options: {
                customHeadRender: (props) => {
                    return (
                        <th key="locatorKey" className="custom-locator">
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <p>{props.label}</p>
                                <SimpleDDL
                                    id="select_options_header_locator"
                                    containerclassname="margin-bottom-none width width-250px"
                                    box="search"
                                    value={this.state.selectedLocator}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            position: "relative",
                                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    options={this.state.dataLocator ? this.state.dataLocator.map(
                                        item => mapToObjectDDL(
                                            item.nameLocation,
                                            item.kodeLocation
                                        )) : []}
                                    onChange={this.handleMultipleLocatorChange}
                                    isClearable={true}
                                />
                            </FlexView>
                        </th>
                    );
                },
                customBodyRender: (val, {rowIndex, rowData}) => {
                    const isSaved = rowData[rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_locator_${rowIndex}`}
                            containerclassname="margin-bottom-none width width-250px"
                            box="search"
                            value={val}
                            menuPosition="fixed"
                            onChange={(value) =>
                                this.handleSingleLocatorChange(rowIndex, value)
                            }
                            options={this.state.dataLocator ? this.state.dataLocator.map(
                                item => mapToObjectDDL(
                                    item.nameLocation,
                                    item.kodeLocation
                                )) : []}
                            readOnly={isSaved}
                            isClearable={true}
                        />
                    );
                },
                sort: false,
            },
        },
        {
            name: "saved",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <FlexView style={{gap: "10px"}}>
                        {
                            !val ?
                                <SimpleButton
                                    className={"btn background-red"}
                                    styles={{width: "unset", marginLeft: "0px"}}
                                    onClick={() => this.handleSaveRow(rowIndex)}
                                    icon={<i className="fa fa-save"/>}
                                />
                                :
                                <SimpleButton
                                    className={"btn background-red"}
                                    styles={{width: "unset", marginLeft: "0px"}}
                                    onClick={() => this.handleEditRow(rowIndex)}
                                    icon={<i className="fa fa-lw fa-pencil-alt"/>}
                                />
                        }
                        <SimpleButton
                            className={"btn background-red"}
                            styles={{width: "unset", marginLeft: "0px"}}
                            onClick={() => this.handleDeleteRow(rowIndex)}
                            icon={<i className="fa fa-trash"></i>}
                        />
                    </FlexView>
                ),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.initialData = {
            kodeVarian: null,
            namaVarian: null,
            frameNumber: null,
            engineNumber: null,
            kodeWarna: null,
            namaWarna: null,
            rfsStatus: false,
            yearManufactured: null,
            kodeLocation: null,
            numberOfPrint: 0,
            saved: false,
        };
        this.state = {
            selectedLocator: null,
            isOpen: false,
            warningModalVisible: false,
            warningMessage: null,
            dataTable: [],
            dataDetailSaved: [],
            dataVariant: [],
            dataWarna: [],
            dataLocator: [],
            dataSupplier: [],
            dataSupplierExpedition: [],
            selectedRow: [],
            pagination:{
                limit: 5,
                page: 1,
                totalData:0
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.fetchDataSupplier();
        this.fetchDataSupplierExpedition();
        this.fetchDataVariant();
        this.fetchDataLocator();
        let kodeCabang = this.props.selectedCabang;
        let spbmNo = await this.fetchDataGenerateSeq(constructGenSeqPayload(kodeCabang))
        this.props.setValue("spbmNo", !R.isNil(spbmNo) ? spbmNo : null)
        this.props.setValue("kodeCabang", kodeCabang)
        this.handleTriggerLoading();
    }

    handleWarningModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleAddRow = () => {
        const newUnit = {
            ...this.initialData,
            id: uuidv4(),
        };

        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable, newUnit],
            dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
        }));
    };

    handleSaveRow = async (index) => {
        this.handleTriggerLoading();
        const {dataTable} = this.state;
        const {engineNumber, id} = dataTable[index];
        const filteredData = dataTable.filter((_, i) => i !== index);
        const isDuplicate = filteredData.some((row) => row.engineNumber === engineNumber);

        let isValidUnit = true;
        const selectedRow = this.state.selectedRow.find(row => row.id === id);
        if (selectedRow?.engineNumber !== engineNumber) {
            const res = await this.fetchCheckValidUnit(
                contructQueryParam({engineNumber: engineNumber})
            )
            isValidUnit = res.ok && res.data.data.valid;
        }


        if (!isDuplicate && isValidUnit) {
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    rfsStatus: newState[index].rfsStatus === 'RFS' ? "RFS" : "NRFS",
                    spbmNo: this.props.controls.spbmNo.value,
                    kodeCabang: this.props.selectedCabang,
                    yearManufactured: newState[index].yearManufactured
                        ? Number(newState[index].yearManufactured)
                        : null,
                    saved: !newState[index].saved,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                    dataDetailSaved: newState,
                };
            });
        } else {
            this.handleWarningModalVisibility("Unit ini sudah terdaftar. Silahkan tambahkan unit lainnya");
        }

        this.handleTriggerLoading();
    };

    handleEditRow = async (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                spbmNo: this.props.controls.spbmNo.value,
                kodeCabang: this.props.selectedCabang,
                yearManufactured: newState[index].yearManufactured
                    ? Number(newState[index].yearManufactured)
                    : null,
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
                selectedRow: [...prevValue.selectedRow, newState[index]],
            };
        });

        const kodeVariant = this.state.dataTable[index].kodeVarian?.value;
        await this.fetchDataWarna({paramFilters: {kodeVariant: kodeVariant}}, index);
    };

    handleDeleteRow = (index) => {
        const {id} = this.state.dataTable[index];
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
            dataDetailSaved: [...prevValue.dataDetailSaved.filter((_, idx) => idx !== index)],
            selectedRow: [...prevValue.selectedRow.filter((item, _) => item.id !== id)],
        }));
    };

    handleMultipleLocatorChange = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedLocator: value,
            dataTable: prevValue.dataTable.map((data) => ({
                ...data,
                kodeLocation: !data.saved ? value : data.kodeLocation,
            })),
        }));
    };

    handleSingleLocatorChange = (index, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                kodeLocation: value,
            };
            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleSelectCodeVariant = async (index, name, value) => {
        if (!R.isEmpty(this.state.dataVariant)) {
            let variant = this.state.dataVariant.find(item => item.kodeVariant === value.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaVarian: variant.namaVariant,
                    frameNumber: variant.digitAwalNoka,
                    engineNumber: variant.digitAwalNosin,
                    kodeWarna: null,
                    namaWarna: null,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });

            await this.fetchDataWarna({paramFilters: {kodeVariant: variant.kodeVariant}}, index);
        }
    };

    handleSelectColorCode = (index, name, value) => {
        if (!R.isEmpty(this.state.dataWarna[index])) {
            let warna = this.state.dataWarna[index].find(item => item.id === value.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaWarnaPabrik: warna.namaWarnaPabrik,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });
        }
    };

    handleValueChange = (index, name, value) => {
        let valueParsed;
        if (R.equals(name, "rfsStatus")) {
            if (R.equals(value, true)) {
                valueParsed = "RFS";
            } else {
                valueParsed = "NRFS";
            }
        } else {
            valueParsed = value;
        }

        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                [name]: valueParsed,
            };

            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleSubmit = () => {
        if (!this.props.validate() || !validateDataDetailUnitNOS(this.state.dataDetailSaved)) {
            this.handleWarningModalVisibility("Ada field data yang perlu diisi atau tidak sesuai kriteria isian.");
        } else {
            let details = constructDataDetailUnitNOS(this.state.dataDetailSaved, this.props.controls);
            this.props.onSubmit("save", this.props.controls, details);
        }
    }

    handleClearForm = () => {
        this.props.resetIgnoreKeys(["spbmNo", "kodeCabang"]);
        this.setState((prevState) => ({
            ...prevState,
            selectedLocator: null,
            dataTable: [],
            // dataTable: prevState.dataTable.map(
            //     item => R.equals(item.saved, false)
            //         ? this.initialData
            //         : item
            // ),
        }));

        this.props.setValue("spbmDate", M(new Date()).format("DD-MM-YYYY"));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataVariant = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataVariant: response.data.data
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    fetchDataWarna = async (body, index) => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam(body);
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataWarna: {...prevState.dataWarna, [index]: response.data.data},
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataSupplier = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSupplierNotExpedition,
            menuName: "Receiving Unit - NOS",
            setError: this.props.setError,
            args: {kodeCabang: this.props.selectedCabang.value},
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplier: res.data.data,
            }));
        }
    }

    fetchDataSupplierExpedition = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
            menuName: "Receiving Unit - NOS",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplierExpedition: res.data.data,
            }));
        }
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchCheckValidUnit = async (body) => {
        try {
            return await Api.create("NAGAMAS_TRANSACTION").checkingValidUnitNOS(body)
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Proses Terima Unit - Manual"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <ReceivingUnitNOSInputs
                                {...this.props}
                                dataSupplier={this.state.dataSupplier}
                                dataSupplierExpedition={this.state.dataSupplierExpedition}
                            />
                            <FlexView vAlignContent="center" className="margin-bottom-10px">
                                <h4 className="margin-right-10px">UNIT MOTOR</h4>
                                <SimpleButton
                                    className={"btn btn-plus background-red margin-left-10px"}
                                    onClick={this.handleAddRow}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah Unit"}
                                />
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.dataTable?.length}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.tableColumns}
                                toCount={this.state.dataTable?.length}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <br/>
                            <FlexView hAlignContent="right">
                                <SimpleButton
                                    
                                    text="Clear"
                                    onClick={() => this.handleClearForm()}
                                />
                                <SimpleButton
                                    
                                    text="Simpan"
                                    onClick={this.handleSubmit}
                                />
                                <SimpleButton
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.props.onClickClose()}
                                />
                            </FlexView>
                        </ModalContainer>
                    }
                />

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    {this.state.warningMessage}
                                    <br/>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleWarningModalVisibility()}
                            />
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default withFormGroup(ReceivingUnitNOSProcess);
